import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { assert } from '@sama/js-core';
import { environment } from 'environments/environment';
import { FeatureFlagService } from '../../core/shared/misc-services/feature-flag.service';
import { createOrUpdateDraftSubmissionsPath } from '../../cross-team-shared/hub-paths';
import { MessagingService } from '../../cross-team-shared/messaging/messaging.service';
import { RollbarService } from '../../cross-team-shared/messaging/rollbar.service';
import { UrlRequestService } from '../../cross-team-shared/misc-services/resources/url-request.service';
import { DraftSubmission } from '../../team-apis/otterdam/draft-submission';

@Injectable()
export class DraftSubmissionResource extends UrlRequestService {
  constructor(
    injector: Injector,
    private featureFlagService: FeatureFlagService,
    private messagingService: MessagingService,
    private rollbarService: RollbarService,
  ) {
    super(injector);
  }

  create_or_update(draft: DraftSubmission, token: string) {
    const draftStart = performance.now();
    return this.request<DraftSubmission>(
      'PUT',
      `${environment.sh3BaseUrl}${createOrUpdateDraftSubmissionsPath()}`,
      {
        body: draft,
        skipDefaultErrorMessaging: true,
        headers: { Authorization: `Bearer ${token}` },
      },
    )
      .then(() => {
        this.logDraftSave('success', draft, draftStart);
      })
      .catch((error: HttpErrorResponse) => {
        this.logDraftSave('failure', draft, draftStart, error);
        if (error.status === 422) {
          this.messagingService.error(
            `Draft save failed. ${error.error.message}`,
          );
        }

        this.rollbarService.error(error);

        throw error;
      });
  }

  private logDraftSave(
    state: 'success' | 'failure',
    draft: DraftSubmission,
    draftStart: number,
    error?: HttpErrorResponse,
  ) {
    if (!this.featureFlagService.hasFlag('log-draft-saves_on')) {
      return;
    }

    if (state === 'success') {
      console.log(
        'Draft saved successfully',
        stringify(getExtraDraftLoggingInfo(draft, draftStart)),
      );
    } else {
      assert(error, 'Draft save failed without error');
      console.log(
        'Draft save error',
        stringify({
          ...getExtraDraftLoggingInfo(draft, draftStart),
          message: error.message,
          status: error.status,
          statusText: error.statusText,
          task: draft.task_id,
        }),
      );
    }
  }
}

function getExtraDraftLoggingInfo(draft: DraftSubmission, draftStart: number) {
  return {
    payload_size: new Blob([draft.value]).size + ' bytes',
    response_time: performance.now() - draftStart + ' ms',
    time: new Date().toUTCString(),
  };
}

function stringify(json: any) {
  return JSON.stringify(json, undefined, 2);
}
